export const BASE_URL = process.env.REACT_APP_API_URL;
export const API_URL = `${BASE_URL}/api`;

//portfolio
export const UPDATE_VIEWS = `${API_URL}/analytics/home-visitor-count`;

// blog
export const BLOGS_URL = `${API_URL}/blogs`;
export const PUBLISHED_BLOGS = `${API_URL}/publishedblogs`;
export const LOGIN_URL = `${API_URL}/login`;
export const REFRESH_TOKEN = `${API_URL}/refresh-token`;
